<template>
  <v-dialog v-model="isOpen" max-width="560px" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $t('two_factor.reminder_title') }}
      </v-card-title>

      <v-card-text>
        <v-alert type="warning" dense outlined class="mb-4">
          {{ $t('two_factor.reminder_subtitle') }}
        </v-alert>

        <ul class="pl-6 body-2">
          <li>{{ $t('two_factor.benefit1') }}</li>
          <li>{{ $t('two_factor.benefit2') }}</li>
          <li>{{ $t('two_factor.benefit3') }}</li>
        </ul>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-btn color="primary" @click="handleEnableNow">
          {{ $t('two_factor.enable_now') }}
        </v-btn>
        <v-spacer />
        <v-btn text @click="handleRemindLater">
          {{ $t('two_factor.remind_later') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus, { OPEN_TWO_FACTOR_REMINDER } from '../util/event-bus'

export default {
  name: 'TwoFactorReminderDialog',

  data() {
    return {
      isOpen: false,
    }
  },

  created() {
    eventBus.$on(OPEN_TWO_FACTOR_REMINDER, () => {
      this.isOpen = true;
    })
  },

  methods: {
    async handleEnableNow() {
      this.isOpen = false
      if (this.$router.currentRoute.name !== 'profile') {
        await this.$router.push({ name: 'profile' });
      }
    },

    handleRemindLater() {
      this.isOpen = false
    }
  }
}
</script>